import { GqlRequestOptions } from '@common/api-request';

import { getZigzinEstimateShippingInfo } from '../graphql/zigzin-estimate-shipping-info.2';
import { checkValidCatalogProductId } from '@common/utils';
import { useQuery } from 'react-query';

export interface GetZigzinEstimateShippingInfoQueryOptionParams {
  catalog_product_id: string;
  final_price: number | null;
  enabled?: boolean;
}

const queryOptions = {
  keepPreviousData: true,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  cacheTime: Infinity,
  staleTime: 5000,
};

export function zigzinEstimateShippingInfoQueryOption(
  params: GetZigzinEstimateShippingInfoQueryOptionParams,
  options?: GqlRequestOptions,
) {
  const enabled = params.enabled === undefined ? true : params.enabled;
  return {
    queryKey: ['getZonlyEstimateShippingInfo'],
    queryFn: async function () {
      const { data } = await getZigzinEstimateShippingInfo(
        { input: { catalog_product_id: params.catalog_product_id, final_price: params.final_price } },
        { ...options, show_alert: false },
      );
      return data?.pdp_zigzin_shipping_base_info;
    },
    ...queryOptions,
    enabled: enabled && checkValidCatalogProductId(params.catalog_product_id),
  };
}

export const useZigzinEstimateShippingInfo = (
  params: GetZigzinEstimateShippingInfoQueryOptionParams,
  options?: GqlRequestOptions,
) => {
  const queryResponse = useQuery(zigzinEstimateShippingInfoQueryOption(params, options));
  return {
    ...queryResponse,
    pdp_zigzin_shipping_base_info: queryResponse.error || !queryResponse.data ? null : queryResponse.data,
  };
};
